import type { TripSummaryItem } from '@/scopes/prices/domain/transports/types'
import { Icon, type IconGlyph } from '@sunwebgroup/uds-ui/icon'
import { Rating } from '@sunwebgroup/uds-ui/rating'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import { useIntl } from '@/intl'
import { transportResponseSelector } from '@/scopes/prices/components/selectors'
import { usePricesSelector } from '@/scopes/prices/infrastructure/usePricesSelector'
import styles from './TripSummary.module.css'

const UDS_MAP: Record<string, IconGlyph> = {
  IconBuilding: 'AppartmentBuilding',
  IconCalendar: 'Calendar',
  IconFamily: 'Family',
  IconAirplaneDeparture: 'AirplaneTakingOff',
  IconAirplaneReturn: 'AirplaneReturn',
  IconCarFront: 'CarFront',
  IconBusRight: 'BusRight',
}

function Item({ header, extraInfo }: TripSummaryItem) {
  const glyph = UDS_MAP[header.icon]

  return (
    <div>
      <div className={styles.headerWrapper}>
        <Icon className={styles.icon} glyph={glyph ?? 'CheckMark'} />
        <Typography variant="body-m-bold-tight">{header.text}</Typography>
        {!!header.stars && <Rating className={styles.stars} rating={header.stars} />}
      </div>
      {extraInfo.map((text, index) => (
        <Typography className={styles.extraInfoText} variant="body-m-regular-tight" key={index}>
          {text}
        </Typography>
      ))}
    </div>
  )
}

export function TripSummary() {
  const { tripSummary } = usePricesSelector(transportResponseSelector)
  const intl = useIntl()
  return (
    <div className={styles.wrapper}>
      <Typography className={styles.title} variant="body-l-bold-tight">{intl.formatMessage({ id: 'price_basket_trip_summary_title' })}</Typography>
      <div className={styles.itemWrapper}>
        {tripSummary?.map((item, index) => <Item key={index} {...item} />)}
      </div>
    </div>
  )
}
